import { appPreloadGuard } from './guards/app-preload.guard';
import { Route } from '@angular/router';


export const appRoutes: Route[] = [

    // ── Private routes (guard applied once via componentless wrapper) ─────────
    {
        path: '',
        canActivate: [appPreloadGuard],
        children: [
            {
                path: 'applications/active',
                loadComponent: () => import('./pages/applications/vendorApplications/active/active-applications.component')
                    .then(m => m.ActiveApplicationsComponent),
            },
            {
                path: 'applications/saved',
                loadComponent: () => import('./pages/applications/stagingApplications/saved/saved-applications.component')
                    .then(m => m.SavedApplicationsComponent),
            },
            {
                path: 'applications/submitted',
                loadComponent: () => import('./pages/applications/stagingApplications/submitted/submitted-applications.component')
                    .then(m => m.SubmittedApplicationsComponent),
            },
            {
                path: 'applications/pre-approved',
                loadComponent: () => import('./pages/applications/vendorApplications/pre-approved/pre-approved-applications.component')
                    .then(m => m.PreApprovedApplicationsComponent),
            },
            {
                path: 'applications/cancelled-declined',
                loadComponent: () => import('./pages/applications/vendorApplications/cancelled-or-declined/cancelled-or-declined-applications.component')
                    .then(m => m.CancelledOrDeclinedApplicationsComponent),
            },
            {
                path: 'applications/closed',
                loadComponent: () => import('./pages/applications/vendorApplications/closed/closed-applications.component')
                    .then(m => m.ClosedApplicationsComponent),
            },
            {
                path: 'applications/legal-deceased-admin',
                loadComponent: () => import('./pages/applications/vendorApplications/legal-deceased-or-admin/legal-deceased-or-admin-applications.component')
                    .then(m => m.LegalDeceasedOrAdminApplicationsComponent),
            },
            { path: 'applications', redirectTo: 'applications/active', pathMatch: 'full' },

            {
                path: 'bookings',
                loadChildren: () => import('./pages/bookings/booking-requests.module')
                    .then(m => m.BookingRequestModule),
            },

            {
                path: 'payouts/unpaid',
                loadComponent: () => import('./pages/payouts/unpaid/unpaid.component')
                    .then(m => m.UnpaidComponent),
            },
            {
                path: 'payouts/paid',
                loadComponent: () => import('./pages/payouts/paid/paid.component')
                    .then(m => m.PaidComponent),
            },
            {
                path: 'payouts/reports',
                loadComponent: () => import('./pages/payouts/payout-reports/payout-reports.component')
                    .then(m => m.PayoutReportsComponent),
            },
            { path: 'payouts', redirectTo: 'payouts/unpaid', pathMatch: 'full' },

            {
                path: 'admin/practice-details',
                loadComponent: () => import('./pages/admin/practice-details/practice-details.component')
                    .then(m => m.PracticeDetailsComponent),
            },
            {
                path: 'admin/practitioner-signature',
                loadComponent: () => import('./pages/admin/practitioner-signature/practitioner-signature.component')
                    .then(m => m.PractitionerSignatureComponent),
            },
            {
                path: 'admin/new-staff-form',
                loadComponent: () => import('./pages/admin/new-staff-form/new-staff-form.component')
                    .then(m => m.NewStaffFormComponent),
            },
            {
                path: 'admin/loan-amendment',
                loadComponent: () => import('./pages/admin/loan-amendment/loan-amendment.component')
                    .then(m => m.LoanAuthorityComponent),
            },
            {
                path: 'admin/customer-information-form',
                loadComponent: () => import('./pages/admin/customer-information-form/customer-information-form.component')
                    .then(m => m.CustomerInformationFormComponent),
            },
            {
                path: 'admin/training',
                loadComponent: () => import('./pages/admin/training/training.component')
                    .then(m => m.TrainingComponent),
            },
            { path: 'admin', redirectTo: 'admin/practice-details', pathMatch: 'full' },
        ],
    },

    // ── Public / unrecognized routes ──────────────────────────────────────────
    {
        path: 'login',
        loadComponent: () => import('./pages/login/login.component')
            .then(m => m.LoginComponent),
    },
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: 'not-found',
        loadComponent: () => import('./pages/not-found/not-found')
            .then(m => m.NotFoundComponent),
    },
    { path: '**', redirectTo: 'not-found', pathMatch: 'full' },
];
